import { render, staticRenderFns } from "./change-password-alert.vue?vue&type=template&id=62837456&scoped=true"
import script from "./change-password-alert.vue?vue&type=script&lang=js"
export * from "./change-password-alert.vue?vue&type=script&lang=js"
import style0 from "./change-password-alert.vue?vue&type=style&index=0&id=62837456&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62837456",
  null
  
)

export default component.exports